/**
 * @desc 获取创建应收账单详情
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(
  params: API.business.paymentOrder.getCreatePaymentOrder.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/getCreatePaymentOrder`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
